import { WritableSignal, signal, Signal, computed } from "@angular/core";

export type NodeInput<T> =
{    
    id?: string, 
    parent?: NodeModel<T>,
    name?: Signal<string>,
    data?: T, 
    depth: number, 
    children?: NodeModel<T>[], 
    isOpen?: boolean,
    metadata?: { [key: string]: string },
    isLeaf?: WritableSignal<boolean>,
    isFolderLeaf?: WritableSignal<boolean>,
}

export class NodeModel<T> {
    public id: string;
    
    public parent: NodeModel<T>;
    public name:WritableSignal<string>|Signal<string>;
    public data: WritableSignal<T>;    
    public children: Signal<NodeModel<T>[]>;
    public metadata?: { [key: string]: string };
    public isRoot: WritableSignal<boolean>;
    public depth: WritableSignal<number>;    
    public isOpen: WritableSignal<boolean>;
    public isLeaf: WritableSignal<boolean>;
    public isFolderLeaf: WritableSignal<boolean>;

    public folderNodes = computed(() =>
        this.children().filter(i=>!i.isLeaf()  ));

    public leafNodes = computed(() =>
        this.children().filter(i=>i.isLeaf()  ));
    
    public hasChildNodes = computed(() => 
        this.children().some(i=>(i.isLeaf() || i.isFolderLeaf() || i.hasChildNodes()  )));

    constructor(request: Partial<NodeInput<T>>)
    {
        this.id = request?.id;
        this.parent = request?.parent;
        this.name = request?.name || signal<string>(null);
        this.data = signal<T>(request?.data);
        this.depth = signal<number>(request?.depth);
        this.children = signal<NodeModel<T>[]>(request?.children || []);
        this.metadata = request?.metadata;      
        this.isOpen = signal<boolean>(request?.isOpen || false);      
        this.isLeaf = request?.isLeaf || signal<boolean>(false);   
        this.isFolderLeaf = request?.isFolderLeaf || signal<boolean>(false);       
    }
}